const BASE_STAKE = 100;

/**
 * Calcule les points et le rang pour chaque joueur
 */
export const computeFootballLeaderboard = (rawList, homeScore, awayScore) => {
    if (!rawList || rawList.length === 0) return [];

    // 1. Calcul des points
    const computed = rawList.map(player => {
        let currentPoints = 0;
        const {betHome, betAway, oddsScore, oddsWin} = player;

        // A. Score Exact
        if (betHome === homeScore && betAway === awayScore) {
            currentPoints += Math.round(BASE_STAKE * (oddsScore || 0));
        }

        // B. Vainqueur
        const actualWinner = getWinner(homeScore, awayScore);
        const betWinner = getWinner(betHome, betAway);

        if (actualWinner === betWinner) {
            currentPoints += Math.round(BASE_STAKE * (oddsWin || 0));
        }

        // Total = points prono (live) + bonus quiz figé (add-on), comme le back
        const quizBonus = player.quizBonus || 0;
        return {
            ...player,
            pronoPoints: currentPoints,
            quizBonus,
            points: currentPoints + quizBonus,
            betDisplay: `${betHome}-${betAway}`
        };
    });

    // 2. Tri (Points > Date > Alpha)
    computed.sort((a, b) => {
        if (b.points !== a.points) return b.points - a.points;
        if (a.betAt !== b.betAt) return new Date(a.betAt) - new Date(b.betAt);
        return (a.pseudo || "").localeCompare(b.pseudo || "");
    });

    // 3. Attribution des rangs
    return computed.map((p, index) => ({
        ...p,
        rank: index + 1,
        style: p.isMe ? 'bg-green-50 border-action-green shadow-sm z-10 scale-[1.01]' : 'bg-slate-50'
    }));
};

// Helper interne
const getWinner = (home, away) => {
    if (home > away) return 'HOME';
    if (away > home) return 'AWAY';
    return 'DRAW';
};